<template>
  <div class="formDialog">
    <el-dialog :title="title"
               visible
               width="900px"
               :close-on-click-modal="false"
               append-to-body
               :before-close="close">
      <div class="public-searchForm">
        <el-form ref="searchForm"
                 inline
                 :model="searchForm"
                 @submit.native.prevent>
          <el-form-item prop="name"
                        label="模型名称">
            <el-input v-model.trim="searchForm.name"
                      size="small"
                      clearable
                      placeholder="请输入表单名称"
                      @keyup.enter.native.stop="search" />
          </el-form-item>
          <el-form-item prop="modelKey"
                        label="模型key">
            <el-input v-model.trim="searchForm.modelKey"
                      size="small"
                      clearable
                      placeholder="请输入表单key"
                      @keyup.enter.native.stop="search" />
          </el-form-item>
          <el-form-item>
            <el-button type="default"
                       size="small"
                       @click="reset">
              重置
            </el-button>
            <el-button type="primary"
                       size="small"
                       @click="search">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-table ref="formModelData"
                :data="formModelData"
                height="300"
                size="small"
                border>
        <el-table-column v-for="item in tableCol"
                         :key="item.key"
                         :prop="item.key"
                         :label="item.label"
                         :minWidth="item.minWidth || 150" />
        <el-table-column label="操作"
                         width="80"
                         fixed="right"
                         align="center">
          <div slot-scope="params"
               class="public-form-table-item-operate">
            <a @click="selectItem(params.row)">选中</a>
          </div>
        </el-table-column>
      </el-table>
      <div class="public-pagination">
        <el-pagination background
                       :current-page="page.current"
                       :page-sizes="page.sizeArray"
                       :page-size="page.size"
                       :total="page.total"
                       :layout="page.layout"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'FormDialog',
  components: {},
  props: {
    modelType: {
      type: Number,
      default: 2
    },
    title: {
      type: String,
      default: '表单引用'
    }
  },
  data() {
    return {
      searchForm: {
        modelType: this.modelType,
        tenantId: '',
        name: '',
        modelKey: ''
      },
      selectParam: {},
      tableCol: [
        { label: '模型ID', key: 'id', minWidth: 200 },
        { label: '名称', key: 'name' },
        { label: '模型key', key: 'modelKey' },
        { label: '模型分类', key: 'categoryName' },
        { label: '创建人', key: 'createdByView', minWidth: 100 },
        { label: '创建时间', key: 'created' },
        { label: '修改人', key: 'lastUpdatedByView', minWidth: 100 },
        { label: '修改时间', key: 'lastUpdated' },
        { label: '描述', key: 'description', minWidth: 220 }
      ],
      page: {
        current: 1,
        size: 10,
        sizeArray: [5, 10, 20, 50, 100],
        total: 0,
        layout: 'sizes, total, jumper, prev, pager, next'
      },
      formModelData: [],
      showSelectForm: false
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.search()
  },
  destroyed() {},
  methods: {
    selectItem(row) {
      this.$emit('formId', row.id, row.name, row.modelKey)
      this.close()
    },
    close() {
      this.$emit('close')
    },
    handleSizeChange(size, fun = 'query') {
      this.page.size = size
      this.page.current = 1
      this[fun]()
    },
    handleCurrentChange(current, fun = 'query') {
      this.page.current = current
      this[fun]()
    },
    reset() {
      this.$refs.searchForm.resetFields()
      this.search()
    },
    search() {
      this.page.current = 1
      this.page.size = 10
      this.selectParam = { ...this.searchForm }
      this.query()
    },
    query() {
      console.log('获取列表')
      const { current, size } = this.page
      this.$api.customerForm
        .getForm({
          pageParam: { current, size },
          selectParam: this.selectParam
        })
        .then((data) => {
          this.formModelData = data.records
          this.page.total = data.total
        })
    }
  }
}
</script>
<style lang='scss' scoped>
</style>
